'use client';
import React, { useEffect, useRef, useState } from 'react';

function useInView(threshold = 0.1) {
  const ref = useRef<HTMLDivElement>(null);
  const [inView, setInView] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {if (entry.isIntersecting) setInView(true);},
      { threshold }
    );
    if (ref?.current) observer?.observe(ref?.current);
    return () => observer?.disconnect();
  }, [threshold]);
  return { ref, inView };
}

const testimonials = [
{
  quote: '"COSA a transformé mon expérience médicale en Côte d\'Ivoire. L\'accueil est chaleureux, les médecins sont compétents et les installations sont modernes. Je recommande vivement ce centre à toute ma famille."',
  img: "https://img.rocket.new/generatedImages/rocket_gen_img_1d8698138-1772995631453.png",
  name: 'Kouassi Ama',
  role: 'Cadre d\'entreprise',
  alt: 'Kouassi Ama cadre entreprise témoignage COSA'
},
{
  quote: '"Grâce au partenariat de COSA avec mon assurance, j\'ai pu bénéficier d\'un suivi médical complet sans tracas administratifs. Les spécialistes sont excellents et l\'environnement est très agréable."',
  img: "https://img.rocket.new/generatedImages/rocket_gen_img_1f2e9ba4e-1772225109827.png",
  name: 'Diallo Fatou',
  role: 'Enseignante',
  alt: 'Diallo Fatou enseignante témoignage COSA'
},
{
  quote: '"Le service de télémédecine de COSA est une révolution ! J\'ai pu consulter un spécialiste depuis chez moi. L\'équipe paramédicale est très professionnelle et attentionnée. Un centre médical d\'excellence."',
  img: "https://img.rocket.new/generatedImages/rocket_gen_img_1d8698138-1772995631453.png",
  name: 'Traoré Moussa',
  role: 'Chef d\'entreprise',
  alt: 'Traoré Moussa chef entreprise témoignage COSA'
}];


export default function OurTestimonials() {
  const { ref, inView } = useInView();
  const [current, setCurrent] = useState(0);

  const prev = () => setCurrent((c) => (c - 1 + testimonials?.length) % testimonials?.length);
  const next = () => setCurrent((c) => (c + 1) % testimonials?.length);

  return (
    <div className="our-testimonials">
      <div className="dentaire-container">
        {/* Section Title */}
        <div className="row section-row">
          <div className="col-lg-12">
            <div className="section-title" style={{ textAlign: 'center', marginBottom: 0 }}>
              <h3>témoignages</h3>
              <h2><span>Ce que Disent</span> Nos Patients</h2>
              <p>La satisfaction de nos patients est notre plus grande récompense.</p>
            </div>
          </div>
        </div>

        <div className="row align-items-center" ref={ref}>
          {/* Left Image */}
          <div className="col-lg-5">
            <div className="testimonial-image">
              <div className="testimonial-img">
                <figure className="reveal image-anime" style={{ display: 'block', overflow: 'hidden', borderRadius: '40px' }}>
                  <img
                    src="/assets/images/testimonials-img.png"
                    alt="Patient satisfait au centre médical COSA"
                    style={{ aspectRatio: '1/1.1', borderRadius: '40px', objectFit: 'cover', width: '100%', display: 'block' }} />
                  
                </figure>
              </div>

              <div className="testimonial-rating-box">
                <div className="rating-counter-item">
                  <div className="rating-counter-number">
                    <h3><span>4.9</span>/5</h3>
                  </div>
                  <div className="rating-counter-content">
                    <p>Note attribuée par nos patients après leur visite au centre COSA</p>
                  </div>
                </div>
                <div className="service-rating">
                  <ul>
                    <li>
                      <i className="fa-solid fa-star"></i>
                      <i className="fa-solid fa-star"></i>
                      <i className="fa-solid fa-star"></i>
                      <i className="fa-solid fa-star"></i>
                      <i className="fa-solid fa-star"></i>
                    </li>
                    <li>pour l'excellence des services</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          {/* Right Slider */}
          <div className="col-lg-7">
            <div className="testimonial-slider">
              <div style={{ overflow: 'hidden' }}>
                <div
                  style={{
                    display: 'flex',
                    transition: 'transform 0.5s ease',
                    transform: `translateX(-${current * 100}%)`
                  }}>
                  
                  {testimonials?.map((t, i) =>
                  <div
                    key={t?.name}
                    style={{ minWidth: '100%', padding: '0 5px' }}>
                    
                      <div className="testimonial-item">
                        <div className="testimonial-header">
                          <div className="testimonial-quote-image">
                            <img
                            src="https://img.rocket.new/generatedImages/rocket_gen_img_1f5ab5100-1764655980423.png"
                            alt="Icône citation" />
                          
                          </div>
                          <div className="testimonial-content">
                            <p>{t?.quote}</p>
                          </div>
                        </div>
                        <div className="testimonial-body">
                          <div className="author-image">
                            <figure className="image-anime">
                              <img src={t?.img} alt={t?.alt} />
                            </figure>
                          </div>
                          <div className="author-content">
                            <h3>{t?.name}</h3>
                            <p>{t?.role}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              <div className="testimonial-btn">
                <div className="testimonial-button-prev" onClick={prev} role="button" aria-label="Témoignage précédent"></div>
                <div className="testimonial-button-next" onClick={next} role="button" aria-label="Témoignage suivant"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>);

}